function validateCheckoutForm(data){
    document.body.dispatchEvent(new CustomEvent('loading_start', { bubbles: true })) // trigger loading

    return gp_ajax({
        url: ghostpress_params.ajax_url + "&action=checkout_validate",
        type: "post",
        dataType: "json",
        data
    })
        .then((response) => {
            if (response.data.has_alerts){
                document.body.dispatchEvent(new CustomEvent('loading_end', { bubbles: true }))
                document.querySelector('.form-checkout-alerts').scrollIntoView({behavior: "smooth"})
                return false
            }

            return true
        })
}

// if the order is paid via PayPal, the payment is captured in the same call to avoid redundant AJAX calls
function createOrder(payPalOrderID = null) {
    document.body.dispatchEvent(new CustomEvent('loading_start', { bubbles: true })) // trigger loading

    let data = {}
    if (payPalOrderID){
        data.paypal_order_id = payPalOrderID
    }

    return gp_ajax({
        url: ghostpress_params.ajax_url + "&action=checkout_create_order",
        type: "post",
        dataType: "json",
        data
    })
}

function processCheckoutForm(e) {
    e.preventDefault()

    let data = new FormData(this)
    data = Object.fromEntries(data.entries())

    validateCheckoutForm(data)
        .then((isValid) => {
            if (!isValid) {
                return
            }

            if (typeof data.payment_method_id !== 'undefined' && data.payment_method_id === 'paypal_card') {
                submitCardFields()
            }
            else {
                createOrder()
            }
        })
        .catch(() => {
            document.body.dispatchEvent(new CustomEvent('loading_end', { bubbles: true }))
        })
}

(function($) {

    $(document).gp_ready(function(){
        // Process checkout form submit
        $('#checkout__form').off('submit').on("submit", processCheckoutForm)

        // Show/hide shipping inputs
        $("form#checkout__form input[name='add_billing_info']").off('change').on('change', toggle_billing_info)
        function toggle_billing_info() {
            $("#form-billing-info").slideToggle(250)
        }

        // Login / register prompt
        let login_input_timer
        $('form#checkout__form input[type="email"]').off('input').on('input', function(){
            clearTimeout(login_input_timer)

            login_input_timer = setTimeout(() => {
                const email = $(this).val()
                if (email.length === 0){
                    $(this).empty()
                }
                else {
                    gp_ajax({
                        url: ghostpress_params.ajax_url + "&action=checkout_possible_login",
                        type: "post",
                        dataType: "json",
                        data: {email}
                    })
                }
            }, 500)
        })

        // Show Apple Pay on checkout only if it is used as a shipping method and the browser supports it
        let browserSupportsApplePay = false;
        let applePayListItem = $('.show-if-apple_pay_available');
        if (applePayListItem.length > 0){

            function maybeShowApplePay(){
                let applePayListItem = $('.show-if-apple_pay_available');

                if (browserSupportsApplePay){
                    applePayListItem.show();
                }
                else {
                    applePayListItem.remove();
                }
            }

            // Determine Apple Pay support
            if (window.ApplePaySession) {

                if (window.location.protocol === "https:"){
                    // canMakePayments() check requires HTTPS
                    if (window.ApplePaySession.canMakePayments()){
                        browserSupportsApplePay = true;
                    }
                }
                else if (window.location.protocol === "http:") {
                    // for localhost testing
                    browserSupportsApplePay = true;
                }

                if (browserSupportsApplePay){
                    // Show Apple Pay on checkout page load
                    maybeShowApplePay();
                }
            }

            /* If Apple Pay is not supported in the current browser and is the first shipping method in the list
               or was used in the previous order (thus is selected by default),
               select the next or previous method as Apple Pay will be hidden */
            if (!browserSupportsApplePay){
                let applePayInput = applePayListItem.find('input[type="radio"]');

                if (applePayInput.is(":checked")){
                    let nextPaymentMethod = applePayListItem.next();

                    // Select the next payment method if there is one
                    if (nextPaymentMethod.length > 0){
                        let nextPaymentMethodInput = nextPaymentMethod.find('input[type="radio"]');
                        nextPaymentMethodInput.prop("checked", true).trigger("click");
                    }
                    // If not, select the previous payment method
                    else {
                        let prevPaymentMethod = applePayListItem.prev();
                        if (prevPaymentMethod.length > 0){
                            let prevPaymentMethodInput = prevPaymentMethod.find('input[type="radio"]');
                            prevPaymentMethodInput.prop("checked", true).trigger("click");
                        }
                    }
                }

                applePayListItem.remove();
            }
        }
    });

})(jQuery);


/* PayPal Expanded Checkout */

const paypalCardFieldStyle = {
    input: {
        'background': '#FFFDF9',
        'border': '1px solid #E3DBD0',
        'border-radius': 0,
        'box-shadow': 'none',
        'font-family': '"Plus Jakarta Sans", sans-serif',
        'font-size': '14px',
        'font-weight': 500,
        'line-height': '150%;',
        'padding': '16px',
    },
    // rules must be more specific to override default PayPal styles
    '.invalid': {
        'border': '1.5px solid #DC4827',
        'box-shadow': 'none',
    },
    'input:focus.invalid': {
        'border': '1.5px solid #DC4827',
        'box-shadow': 'none',
    },
    '.invalid::placeholder': { color: '#DC4827' },
    'input:focus': {
        'border': '1px solid #E3DBD0',
        'box-shadow': 'none'
    },
}

let cardFields
let numberField, expiryField, cvvField

const cardFieldsOptions = {
    createOrder: createPayPalOrder,
    onApprove,
    onError,
    style: paypalCardFieldStyle,
}

export async function renderPayPalCardFields() {
    cardFields = paypal.CardFields(cardFieldsOptions)

    // Render each field after checking for eligibility
    if (cardFields.isEligible()) {
        numberField = cardFields.NumberField({placeholder: '0000 0000 0000 0000'})
        expiryField = cardFields.ExpiryField({placeholder: scripts_translations.checkout.card_expiry_placeholder})
        cvvField = cardFields.CVVField({placeholder: '000'})

        await Promise.all([
            numberField.render("#card-number-field-container"),
            expiryField.render("#card-expiry-field-container"),
            cvvField.render("#card-cvv-field-container")
        ])
    }
}

export async function removePayPalCardFields() {
    if (typeof cardFields !== 'undefined' && cardFields.isEligible()) {

        await Promise.all([
            numberField && numberField.close(),
            cvvField && cvvField.close(),
            expiryField && expiryField.close()
        ])

        numberField = expiryField = cvvField = undefined
        cardFields = undefined
    }
}

function submitCardFields(){

    // Get card field errors
    cardFields.getState().then((state) => {

        if (!state.isFormValid) {
            document.body.dispatchEvent(new CustomEvent('loading_end', { bubbles: true }))

            // Mark invalid fields
            const fieldErrorsMap = {
                'INVALID_NUMBER': numberField,
                'INVALID_EXPIRY': expiryField,
                'INVALID_CVV': cvvField,
            }
            let isFirstError = true
            Object.entries(fieldErrorsMap).forEach(([errorCode, field]) => {
                if (state.errors.includes(errorCode)) {
                    if (isFirstError) {
                        isFirstError = false
                        field.focus() // focus the first errored field
                    }

                    field.addClass('invalid')
                } else {
                    field.removeClass('invalid')
                }
            })

            return // don't submit invalid fields
        }

        let addressData = {}
        const addressLine1 = document.getElementById("input-billing_address_line_1")
        if (addressLine1){
            addressData = {
                billingAddress: {
                    addressLine1: addressLine1.value,
                    countryCode: document.getElementById("input-billing_country").value,
                    postalCode: document.getElementById("input-billing_zip").value,
                },
            }
        }

        const watchdog = watch3DSCancel(() => {
            onError({ name: 'USER_CANCELLED_3DS', message: 'User closed 3DS popup' })
        })

        cardFields.submit(addressData)
            .then(() => {
                watchdog.cancel()
            })
            .catch((error) => {
                watchdog.cancel()
                onError(error)
            })
    })
}

function createPayPalOrder() {
    return gp_ajax({
        url: ghostpress_params.ajax_url + "&action=paypal_create_order",
        type: "post",
        dataType: "json",
    })
        .then((response) => {
            if (response.data.paypal_order_id) { // PayPal Expanded Checkout requires an order ID
                return response.data.paypal_order_id
            }

            return true
        })
}

function onApprove(data) {
    createOrder(data.orderID)
}

function onError(error){
    document.body.dispatchEvent(new CustomEvent('loading_end', { bubbles: true }))

    if (typeof error.name !== 'undefined' && error.name === 'USER_CANCELLED_3DS') {
        return
    }

    numberField.addClass('invalid')
    expiryField.addClass('invalid')
    cvvField.addClass('invalid')
}

// CVV tooltip for mobile
document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.querySelector('.cvv-tooltip__trigger')
    const bubble = document.querySelector('.cvv-tooltip__bubble')

    if (!trigger || !bubble) return

    function showTooltip() {
        bubble.classList.add('is-visible')
    }

    function hideTooltip() {
        bubble.classList.remove('is-visible')
    }

    function toggleTooltip(e) {
        e.stopPropagation()
        bubble.classList.contains('is-visible') ? hideTooltip() : showTooltip()
    }

    trigger.addEventListener('click', toggleTooltip)

    document.addEventListener('click', function (e) {
        if (!bubble.contains(e.target) && e.target !== trigger) {
            hideTooltip()
        }
    })

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') hideTooltip()
    })
})

// 3D Secure popup close handler (PayPal doesn't throw any errors etc.)
function watch3DSCancel(onCancelDetected) {
    let settled = false

    function handler(e) {
        if (settled) return
        if (typeof e.origin !== 'string' || !e.origin.includes('paypal.com')) return

        const raw = typeof e.data === 'string' ? e.data : JSON.stringify(e.data)

        if (raw.includes('"message":"Component closed"')) {
            settled = true
            window.removeEventListener('message', handler)
            onCancelDetected()
        }
    }

    window.addEventListener('message', handler)

    return {
        cancel() {
            settled = true
            window.removeEventListener('message', handler)
        }
    }
}
